import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  connectModal,
} from '@gsa/afp-component-library';
import MakeModelEditContent from '../edit-make-model/edit-make-model-content';
import { MakeModelPanelProvider } from '../Providers/make-model-panel-provider';


const MakeModelEditModal = ({
  data,
  isOpen,
  onClose,
  refetchData,
}) => {
  const initialState = {
    bodyMake: {
      makeName: data?.make?.makeName || '',
      makeCode: data?.make?.makeCode || '',
    },
    bodyModel: {
      modelName: data?.modelName || '',
      modelCode: data?.modelCode || '',
    },
  };

  const modalTitle = 'Edit make and model';

  return (
    <Modal
      id="make-model-edit-modal"
      variant="large"
      title={
        <h2 tabIndex="0" aria-label={modalTitle}>
          {modalTitle}
        </h2>
      }
      onClose={onClose}
      isOpen={isOpen}
    >
      <MakeModelPanelProvider initialState={initialState}>
        <MakeModelEditContent
          data={data}
          onClose={onClose}
          refetchData={refetchData}
        />
      </MakeModelPanelProvider>
    </Modal>
  );
};

MakeModelEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    make: PropTypes.object.isRequired,
    modelCode: PropTypes.string.isRequired,
    modelName: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  refetchData: PropTypes.func.isRequired,
};

const MakeModelEditConnectModal = connectModal(MakeModelEditModal);

export default MakeModelEditConnectModal;
